import React, { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
//
import colors from 'theme/colors';

const { darkBorder, darkInputBorder, disabledFont, fontBody, labelPlatinum, onyx40, yellow } = colors;

const Container = styled.div<{ disabled: boolean }>`
  align-items: center;
  border: ${props => `1px solid ${props.disabled ? darkBorder : labelPlatinum}`};
  border-radius: 3px;
  color: ${props => (props.disabled ? darkBorder : labelPlatinum)};
  display: flex;
  font-size: 16px;
  font-weight: 500;
  height: 34px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0px 4px 0px 8px;
  position: relative;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    background-color: ${props => (props.disabled ? 'transparent' : 'rgba(0, 0, 0, 0.3)')};
  }
`;

const CheckboxContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  top: 2px;
`;

const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  pointer-events: none;

  &:checked + span {
    background-color: #fff;
  }

  &:checked + span:after {
    display: block;
  }
`;

const CheckboxReadOnly = styled(Checkbox)`
  &:checked + span {
    background-color: ${darkInputBorder};
  }
`;

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #eee;
  border: 1px solid ${onyx40};
  border-radius: 3px;

  &:after {
    content: '';
    position: absolute;
    display: none;

    left: 4px;
    top: 0px;
    width: 5px;
    height: 10px;
    border: solid ${fontBody};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const CheckmarkReadOnly = styled(Checkmark)`
  &:after {
    border-color: ${disabledFont};
  }
`;

const Label = styled.div`
  margin-left: 26px;
`;

const StyledMenuOpenIcon = styled(MenuOpenIcon)`
  width: 8px;
  height: 8px;
`;

const StyledMenuOpenIconComplete = styled(StyledMenuOpenIcon)`
  color: ${yellow};
`;

interface IFormulaModalButtonProps {
  complete: boolean;
  enabled?: boolean;
  disabled?: boolean;
  label: string;
  onCheckboxClick?: () => void;
  onGeneralClick: () => void;
}

export default ({ complete, enabled, label, onGeneralClick, onCheckboxClick, disabled }: IFormulaModalButtonProps) => {
  // Check for which element was clicked
  function handleClick(event: BaseSyntheticEvent) {
    if (disabled) {
      return;
    }
    if (event.target.tagName === 'SPAN' && onCheckboxClick) {
      // Checkbox
      onCheckboxClick();
    } else {
      // Everything else
      onGeneralClick();
    }
  }

  // States: disabled, enabled, enabled (readOnly)
  function renderCheckbox() {
    if (disabled) {
      return (
        <>
          <CheckboxReadOnly type="checkbox" disabled />
          <Checkmark />
        </>
      );
    }

    if (enabled && !onCheckboxClick) {
      return (
        <>
          <CheckboxReadOnly type="checkbox" checked readOnly />
          <CheckmarkReadOnly />
        </>
      );
    }

    return (
      <>
        <Checkbox type="checkbox" checked={enabled} readOnly />
        <Checkmark />
      </>
    );
  }

  return (
    <Container onClick={handleClick} disabled={!!disabled}>
      <div>
        <CheckboxContainer>{renderCheckbox()}</CheckboxContainer>
        <Label>{label}</Label>
      </div>
      {complete ? <StyledMenuOpenIconComplete /> : <StyledMenuOpenIcon />}
    </Container>
  );
};
